package stb.format.vorbis.data;

/**
 * ...
 * @author shohei909
 */
class IntPoint
{
    public var x:Int;
    public var y:Int;

    public function new() {

    }
}
